<template>
	<el-dialog :title="title" v-model="isShow" :style="{'width': dialogWidth + 'px','margin':'0px'}" :show-close="isShowClose" @close="rightTopClose" :append-to-body="appendToBody">
		
		<!-- 弹框主内容 -->
		<slot name="dialogbody"></slot>
		<!-- 弹框底部 -->
		
		<template #footer v-if="showFooter">
			<span class="dialog-footer" v-if="footerBtnType == 'cancelAndConfirm'">
				<el-button size="large" @click="close">{{closeText}}</el-button>
				<el-button size="large" type="primary" @click="confirm($event)">{{confirmText}}</el-button>
			</span>
			
			<span class="dialog-footer" v-if="footerBtnType == 'close'">
				<el-button type="primary" size="large" @click="close">{{closeText}}</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: "basedialog",
		props:{
			titleClass:{
				default:'dialogHeaderTit'
			},
			title:{
				default:'添加'
			},
            isShowClose:{
                default:true
            },
			dialogVisible:{
				default:false
			},
			closeText:{
				default:'取消'
			},
			confirmText:{
				default:'确认'
			},
			dialogWidth:{
				default:800
			},
			showFooter: {
				default: true
			},
			footerBtnType: {
				default: "cancelAndConfirm"
			},
			appendToBody: {
				default: false
			},//是否是嵌套的弹框
		},
		data() {
			return {
				isShow: this.dialogVisible
			}
		},
		watch: {
			dialogVisible(val){
				this.isShow = val;
				if(this.isShow){
					/* setTimeout(()=>{
						for(let i = 0;i<document.getElementsByClassName('el-overlay-dialog').length;i++){
							let dialogBodyHeight = document.getElementsByClassName('el-overlay-dialog')[0].getBoundingClientRect().height;
							console.log('dialogBodyHeight::',dialogBodyHeight)
							if(dialogBodyHeight != 0){
								document.getElementsByClassName('el-overlay-dialog')[0].getElementsByClassName('el-dialog__body')[0].style.maxHeight = this.dialogHeight || (dialogBodyHeight - 186) + 'px';
							}
						}
					},200) */
					setTimeout(()=>{
						for(let i = 0; i<document.getElementsByClassName('el-overlay-dialog').length; i++){
							let item = document.getElementsByClassName('el-overlay-dialog')[i];
							let dialogBodyHeight = item.getBoundingClientRect().height;
							if(dialogBodyHeight != 0){
								item.getElementsByClassName('el-dialog__body')[0].style.maxHeight = this.dialogHeight || (dialogBodyHeight - 186) + 'px';
							}
						}
					},500)
				}
			}
		},
		created() {
		},
		methods:{
			/**
			 * 点击取消按钮
			 */
			close(){
				this.$emit('dialogClose');
			},
			/**
			 * 点击确认按钮
			 */
			confirm(evt){
        let target = evt.target;
        if(target.nodeName == "SPAN"){
          target = evt.target.parentNode;
        }
        target.blur();
				this.$emit('dialogConfirm');
			},
			/**
			 * 右上角关闭
			 */
			rightTopClose(){
				this.$emit('dialogRightTopClose');
			}
		}
	}
</script>

<style>
	.el-overlay-dialog{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.el-dialog{
		border-radius: 10px;
		box-shadow: 0px 2px 48px 0px rgba(57,0,115,0.21);
	}
	.el-dialog__header{
		/* padding: 0; */
		/* margin: 0; */
	}
	.dialogHeader{
		height: 67px;
		border-bottom: 1px solid #F2F1F6;
		padding: 0 20px;
	}
	.dialogHeader .dialogHeaderTit{
		font-size: 18px;
		color: #FF4FA6;
		font-weight: 600;
		letter-spacing: 1px;
		display: flex;
		align-items: center;
	}
	.dialogHeader .dialogHeaderTit img{
		width: 48px;
		height: 48px;
		margin-right: 10px;
	}
	.dialogHeaderClose{
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		margin-right: -10px;
	}
	.dialogHeaderClose img{
		width: 35px;
		height: 35x;
	}
	.el-dialog__footer{
		padding: 0;
	}
	.dialog-footer{
		height: 67px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		/* border-top: 1px solid #F2F1F6; */
	}
	.dialog-footer .el-button{
		min-width: 90px;
		height: 30px;
		line-height: 30px;
		padding: 0;
		margin: 0 20px;
	}
	.el-dialog__body{
		padding: 20px;
		box-sizing: border-box;
		overflow-y: scroll;
		/* max-height:500px; */
	}
</style>
